import React from 'react';
import { motion } from 'framer-motion';

export const DeployIcon: React.FC<{ isActive: boolean }> = ({ isActive }) => {
	return (
		<motion.svg
			animate={isActive ? { scale: 1.2 } : null}
			width="100%"
			height="100%"
			viewBox="0 0 64 66"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19.2103 41.3527L29.7754 47.4525C55.0225 22.0218 45.1388 8.64234 45.1388 8.64234C45.1388 8.64234 28.3721 7.18324 19.2103 41.3527Z"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
			/>
			<path
				d="M40.3349 35.2634L42.7579 46.6147C42.8279 46.9426 42.7289 47.2838 42.4942 47.5233L35.2219 54.9453C34.7575 55.4193 33.9685 55.3177 33.6393 54.7414L29.6248 47.7134"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
			/>
			<path
				d="M24.4855 26.1136L13.4434 29.6909C13.1244 29.7942 12.8784 30.0506 12.7883 30.3736L9.99687 40.3825C9.81858 41.0218 10.3011 41.6542 10.9647 41.6511L19.0584 41.6138"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
			/>
			<path
				d="M22.5229 47.569C24.6151 48.7943 25.4338 51.9275 24.2086 54.0197C22.5626 56.8302 17.7148 58.5617 16.1846 59.0502C16.1248 59.0702 16.0615 59.0771 15.9988 59.0706C15.9361 59.0641 15.8756 59.0442 15.8212 59.0124C15.7668 58.9805 15.7199 58.9374 15.6835 58.886C15.6471 58.8345 15.6222 58.7758 15.6104 58.7139C15.2878 57.1404 14.4262 52.0652 16.0722 49.2547C17.2975 47.1625 20.4307 46.3437 22.5229 47.569Z"
				fill="#F27C00"
			/>
			<circle
				cx="36.1672"
				cy="24.1666"
				r="3.05014"
				transform="rotate(30 36.1672 24.1666)"
				fill="#F27C00"
			/>
		</motion.svg>
	);
};
